import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  ExclamationTriangleIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';

const SuperAdminPurges = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const handlePurgeServices = async () => {
    if (confirmText !== 'SUPPRIMER') {
      alert('Veuillez taper "SUPPRIMER" pour confirmer');
      return;
    }

    if (!window.confirm('⚠️ ATTENTION : Cette action est IRRÉVERSIBLE et supprimera TOUS les services de la base de données. Êtes-vous absolument certain ?')) {
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/super-admin/purge/services`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert(`✅ ${response.data.deletedCount} service(s) supprimé(s) avec succès`);
      setConfirmText('');
    } catch (error) {
      console.error('Erreur purge services:', error);
      alert(error.response?.data?.message || 'Erreur lors de la purge des services');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* En-tête */}
        <div className="mb-6">
          <button
            onClick={() => navigate('/super-admin/dashboard')}
            className="text-gray-600 hover:text-gray-900 mb-4"
          >
            ← Retour au tableau de bord
          </button>
          <h1 className="text-3xl font-bold text-gray-900">Purges de données</h1>
          <p className="text-gray-600 mt-2">
            Actions de suppression massive de données (réservé au super admin)
          </p>
        </div>

        {/* Avertissement général */}
        <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-6 rounded-r-lg">
          <div className="flex items-start">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-500 mr-3 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-lg font-semibold text-red-800 mb-2">
                ⚠️ DANGER - Actions irréversibles
              </h3>
              <p className="text-red-700 text-sm">
                Les actions de purge sont <strong>définitives et irréversibles</strong>. 
                Aucune sauvegarde automatique n'est effectuée. Assurez-vous d'avoir une 
                sauvegarde de la base de données avant d'effectuer ces opérations.
              </p>
            </div>
          </div>
        </div>

        {/* Purge des services */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <div className="flex items-start mb-4">
            <TrashIcon className="h-6 w-6 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                Supprimer tous les services
              </h2>
              <p className="text-gray-600 text-sm mb-4">
                Cette action supprimera <strong>TOUS les services</strong> de la base de données, 
                y compris les services UNAF et miellerie, leurs paiements, attestations et historiques.
              </p>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
                <p className="text-sm text-yellow-800 font-medium mb-2">
                  Cette action supprimera :
                </p>
                <ul className="text-sm text-yellow-700 space-y-1 ml-4">
                  <li>• Tous les services UNAF (assurances, revues, etc.)</li>
                  <li>• Tous les services miellerie</li>
                  <li>• Tous les paiements associés</li>
                  <li>• Toutes les attestations</li>
                  <li>• Tout l'historique des modifications</li>
                </ul>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tapez "SUPPRIMER" pour confirmer
                </label>
                <input
                  type="text"
                  value={confirmText}
                  onChange={(e) => setConfirmText(e.target.value)}
                  placeholder="SUPPRIMER"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                />
              </div>

              <button
                onClick={handlePurgeServices}
                disabled={loading || confirmText !== 'SUPPRIMER'}
                className="w-full px-6 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
              >
                <TrashIcon className="h-5 w-5 mr-2" />
                {loading ? 'Suppression en cours...' : 'Supprimer tous les services'}
              </button>
            </div>
          </div>
        </div>

        {/* Note de sécurité */}
        <div className="bg-gray-100 border border-gray-300 rounded-lg p-4">
          <p className="text-sm text-gray-700">
            <strong>Note :</strong> Ces opérations sont réservées au super administrateur 
            et nécessitent une authentification spéciale. En cas de doute, contactez 
            l'équipe technique avant d'effectuer ces actions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminPurges;
